module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ticket_page),
      expression: "!ticket_page"
    }],
    staticClass: "clerkWrap"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "bu-name overhide",
    attrs: {
      "title": ((_vm.buInfo.bu_name) + "（" + (_vm.buInfo.user_count) + "人）")
    }
  }, [_vm._v(_vm._s(((_vm.buInfo.bu_name) + "（" + (_vm.buInfo.user_count) + "人）")))]), _vm._v(" "), _c('div', {
    staticClass: "bu-leader"
  }, [_vm._v("合伙人：" + _vm._s(_vm.buInfo.bu_manager_name))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v("BU创建时间：" + _vm._s(_vm._f("justDate")(_vm.buInfo.created_at)))])]), _vm._v(" "), _c('div', {
    staticClass: "other"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "overhide",
    attrs: {
      "title": _vm.buInfo.bu_description || '暂无描述'
    }
  }, [_vm._v("BU描述：" + _vm._s(_vm.buInfo.bu_description || "暂无描述"))]), _vm._v(" "), _c('div', [_vm._v("经营范围：" + _vm._s(_vm.describe_str || "暂无"))])]), _vm._v(" "), _c('div', {
    staticClass: "func"
  }, [_c('div', {
    staticClass: "front-btn green",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.pop.changeFlag = true
      }
    }
  }, [_vm._v("调岗")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn green",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.pop.addFlag = true
      }
    }
  }, [_vm._v("增岗")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn red",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        (function () {
          _vm.getTicketList();
          _vm.ticket_page = true
        })($event)
      }
    }
  }, [_vm._v("罚单")]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-item"
  }, _vm._l((_vm.bu_users), function(item) {
    return _c('personbox', {
      key: item.id,
      attrs: {
        "info": item
      },
      on: {
        "click": _vm.openUserPop
      }
    })
  }))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ticket_page),
      expression: "ticket_page"
    }],
    staticClass: "ticket-detail"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "func"
  }, [_c('span', [_vm._v("罚单类型：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ticket_search_type),
      callback: function($$v) {
        _vm.ticket_search_type = $$v
      },
      expression: "ticket_search_type"
    }
  }, _vm._l((_vm.personalTicket), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.ticket_name,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("罚单日期")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.datePick_start),
      callback: function($$v) {
        _vm.datePick_start = $$v
      },
      expression: "datePick_start"
    }
  }), _vm._v(" "), _c('span', [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.datePick_end),
      callback: function($$v) {
        _vm.datePick_end = $$v
      },
      expression: "datePick_end"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "front-btn green",
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('div', {
    staticClass: "front-btn red",
    on: {
      "click": function($event) {
        _vm.pop.ticketFlag = true
      }
    }
  }, [_vm._v("开罚单")])], 1), _vm._v(" "), _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.ticketListClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("罚单日期\n                        "), _c('div', {
    staticClass: "angle-wrap"
  }, [_c('i', {
    staticClass: "el-icon-caret-top",
    class: {
      active: _vm.sort[0]
    },
    on: {
      "click": function($event) {
        _vm.sortList(0)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom",
    class: {
      active: _vm.sort[1]
    },
    on: {
      "click": function($event) {
        _vm.sortList(1)
      }
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("罚单编号")]), _vm._v(" "), _c('div', [_vm._v("罚单对象")]), _vm._v(" "), _c('div', [_vm._v("罚单类型")]), _vm._v(" "), _c('div', [_vm._v("快币金额(币/人)")]), _vm._v(" "), _c('div', [_vm._v("罚单原因")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "list-detail"
  }, [_vm._l((_vm.ticket_list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(_vm._f("justDate")(item.created_at)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "0"
      }
    }, [_c('div', {
      staticClass: "text-hide"
    }, [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('div', {
      staticClass: "more"
    }, [_vm._v(_vm._s(item.real_name))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.ticket_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.ticket_amount))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.remark
      }
    }, [_vm._v(_vm._s(item.remark))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.ticket_list
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    staticClass: "inside",
    attrs: {
      "data": _vm.ticket_data
    },
    on: {
      "getPage": _vm.search
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "form",
      rawName: "v-form:changePost",
      arg: "changePost"
    }],
    attrs: {
      "title": "调岗申请",
      "visible": _vm.pop.changeFlag
    },
    on: {
      "open": function($event) {
        _vm.openFocus('area_change')
      },
      "close": function($event) {
        _vm.changeClose()
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "changeFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("调岗类型：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.changeType),
      expression: "pop.changeType"
    }],
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.pop.changeType),
      callback: function($$v) {
        _vm.$set(_vm.pop, "changeType", $$v)
      },
      expression: "pop.changeType"
    }
  }, _vm._l((_vm.pop.changeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("调岗人员：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.changeIds.join(',')),
      expression: "pop.changeIds.join(',')"
    }],
    staticStyle: {
      "width": "452px"
    },
    attrs: {
      "rule": "noVal",
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "请选择调岗人员"
    },
    model: {
      value: (_vm.pop.changeIds),
      callback: function($$v) {
        _vm.$set(_vm.pop, "changeIds", $$v)
      },
      expression: "pop.changeIds"
    }
  }, _vm._l((_vm.changeUsers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.real_name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("申请理由：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.changeReason),
      expression: "pop.changeReason"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['申请理由']),
      expression: "['申请理由']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.changeReason),
      expression: "pop.changeReason"
    }],
    ref: "area_change",
    attrs: {
      "rule": "reason"
    },
    domProps: {
      "value": (_vm.pop.changeReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "changeReason", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.changeFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm_change
    }
  }, [_vm._v("提交申请")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "form",
      rawName: "v-form:addPost",
      arg: "addPost"
    }],
    attrs: {
      "title": "增岗申请",
      "visible": _vm.pop.addFlag
    },
    on: {
      "close": function($event) {
        _vm.addClose()
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "addFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("岗位名称：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.addNameId),
      expression: "pop.addNameId"
    }],
    attrs: {
      "rule": "noVal",
      "z-noData-text": "暂无职位，需自行添加",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.pop.addNameId),
      callback: function($$v) {
        _vm.$set(_vm.pop, "addNameId", $$v)
      },
      expression: "pop.addNameId"
    }
  }, _vm._l((_vm.addPosts), function(item) {
    return _c('z-limitOption', {
      key: item.id,
      attrs: {
        "label": item.positionName,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticClass: "add-post",
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.openEdit()
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pop.add_inputFlag),
      expression: "pop.add_inputFlag"
    }],
    staticClass: "add-input",
    on: {
      "mouseover": function($event) {
        _vm.pop.add_hover = true
      },
      "mouseleave": function($event) {
        _vm.pop.add_hover = false
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.add_editText),
      expression: "pop.add_editText"
    }],
    ref: "post_input",
    attrs: {
      "placeholder": "请输入岗位名称"
    },
    domProps: {
      "value": (_vm.pop.add_editText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.uploadEdit()
      },
      "blur": function($event) {
        _vm.hideEdit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "add_editText", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        _vm.clearEdit()
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pop.add_up_ing),
      expression: "!pop.add_up_ing"
    }],
    ref: "add_check",
    staticClass: "el-icon-check",
    on: {
      "click": function($event) {
        _vm.uploadEdit()
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pop.add_up_ing),
      expression: "pop.add_up_ing"
    }],
    staticClass: "el-icon-loading"
  })])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("增岗类型：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.addType),
      expression: "pop.addType"
    }],
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.pop.addType),
      callback: function($$v) {
        _vm.$set(_vm.pop, "addType", $$v)
      },
      expression: "pop.addType"
    }
  }, _vm._l((_vm.pop.addOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("增岗人数：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.addNum),
      expression: "pop.addNum"
    }],
    attrs: {
      "rule": "noVal integer",
      "placeholder": "请输入数字"
    },
    model: {
      value: (_vm.pop.addNum),
      callback: function($$v) {
        _vm.$set(_vm.pop, "addNum", $$v)
      },
      expression: "pop.addNum"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("岗位需求：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.addRequire),
      expression: "pop.addRequire"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['岗位需求']),
      expression: "['岗位需求']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.addRequire),
      expression: "pop.addRequire"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入岗位需求"
    },
    domProps: {
      "value": (_vm.pop.addRequire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "addRequire", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("申请理由：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.addReason),
      expression: "pop.addReason"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['申请理由']),
      expression: "['申请理由']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.addReason),
      expression: "pop.addReason"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入申请理由"
    },
    domProps: {
      "value": (_vm.pop.addReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "addReason", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.addFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm_add
    }
  }, [_vm._v("提交申请")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "form",
      rawName: "v-form:ticket",
      arg: "ticket"
    }],
    attrs: {
      "title": "职员罚单",
      "visible": _vm.pop.ticketFlag
    },
    on: {
      "close": function($event) {
        _vm.ticketClose()
      },
      "update:visible": function($event) {
        _vm.$set(_vm.pop, "ticketFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("处罚对象：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.ticketIds),
      expression: "pop.ticketIds"
    }],
    staticStyle: {
      "width": "452px"
    },
    attrs: {
      "rule": "noVal",
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.pop.ticketIds),
      callback: function($$v) {
        _vm.$set(_vm.pop, "ticketIds", $$v)
      },
      expression: "pop.ticketIds"
    }
  }, _vm._l((_vm.changeUsers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.real_name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("罚单类型：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.ticketType),
      expression: "pop.ticketType"
    }],
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.pop.ticketType),
      callback: function($$v) {
        _vm.$set(_vm.pop, "ticketType", $$v)
      },
      expression: "pop.ticketType"
    }
  }, _vm._l((_vm.worker_ticket), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.ticket_name,
        "value": item.id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title must"
  }, [_vm._v("处罚原因：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pop.ticketReason),
      expression: "pop.ticketReason"
    }, {
      name: "arg",
      rawName: "v-arg",
      value: (['处罚原因']),
      expression: "['处罚原因']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.pop.ticketReason),
      expression: "pop.ticketReason"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入处罚原因"
    },
    domProps: {
      "value": (_vm.pop.ticketReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pop, "ticketReason", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.pop.ticketFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm_ticket
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "user-window",
    attrs: {
      "title": "职员数据",
      "size": 'large',
      "visible": _vm.user.userFlag
    },
    on: {
      "open": function($event) {
        _vm.getUserData()
      },
      "close": function($event) {
        _vm.userClear()
      },
      "update:visible": function($event) {
        _vm.$set(_vm.user, "userFlag", $event)
      }
    }
  }, [_c('div', {
    staticClass: "user-tab-head"
  }, [_c('div', {
    staticClass: "title",
    class: {
      active: _vm.user.userActiveIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.user.userActiveIndex = 0
      }
    }
  }, [_vm._v("结算明细")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    class: {
      active: _vm.user.userActiveIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.user.userActiveIndex = 1
      }
    }
  }, [_vm._v("罚单明细")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    class: {
      active: _vm.user.userActiveIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.user.userActiveIndex = 2
      }
    }
  }, [_vm._v("职级明细")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.userActiveIndex == 0),
      expression: "user.userActiveIndex==0"
    }],
    staticClass: "func"
  }, [_c('span', [_vm._v("年度：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.user.bonusYear),
      callback: function($$v) {
        _vm.$set(_vm.user, "bonusYear", $$v)
      },
      expression: "user.bonusYear"
    }
  }, _vm._l((_vm.bonusYearOptions), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("周期：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": "",
      "placeholder": "请选择",
      "z-noData-text": "请先选择年份"
    },
    model: {
      value: (_vm.user.bonusCycleId),
      callback: function($$v) {
        _vm.$set(_vm.user, "bonusCycleId", $$v)
      },
      expression: "user.bonusCycleId"
    }
  }, _vm._l((_vm.bonusCycleOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.cycle_number_show,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "front-btn green shift",
    on: {
      "click": function($event) {
        _vm.bonusSearch()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.userActiveIndex == 1),
      expression: "user.userActiveIndex==1"
    }],
    staticClass: "func"
  }, [_c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.user.datePick_start),
      callback: function($$v) {
        _vm.$set(_vm.user, "datePick_start", $$v)
      },
      expression: "user.datePick_start"
    }
  }), _vm._v(" "), _c('small', [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.user.datePick_end),
      callback: function($$v) {
        _vm.$set(_vm.user, "datePick_end", $$v)
      },
      expression: "user.datePick_end"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("罚单类型：")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.user.typeId),
      callback: function($$v) {
        _vm.$set(_vm.user, "typeId", $$v)
      },
      expression: "user.typeId"
    }
  }, _vm._l((_vm.personalTicket), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.ticket_name
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "front-btn green shift",
    on: {
      "click": function($event) {
        _vm.userTicketSearch()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.userActiveIndex == 2),
      expression: "user.userActiveIndex==2"
    }],
    staticClass: "func"
  }, [_c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.user.pmt_datePick_start),
      callback: function($$v) {
        _vm.$set(_vm.user, "pmt_datePick_start", $$v)
      },
      expression: "user.pmt_datePick_start"
    }
  }), _vm._v(" "), _c('small', [_vm._v("~")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "top-choose",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.user.pmt_datePick_end),
      callback: function($$v) {
        _vm.$set(_vm.user, "pmt_datePick_end", $$v)
      },
      expression: "user.pmt_datePick_end"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "front-btn green shift",
    on: {
      "click": function($event) {
        _vm.searchUserPmt()
      }
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "user-tab-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.userActiveIndex == 0),
      expression: "user.userActiveIndex==0"
    }]
  }, [_c('div', {
    staticClass: "user-list settle"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v("奖金周期")]), _vm._v(" "), _c('div', [_vm._v("周期跨度")]), _vm._v(" "), _c('div', [_vm._v("结算单生成日期")]), _vm._v(" "), _c('div', [_vm._v("结算单确认日期")]), _vm._v(" "), _c('div', [_vm._v("是否已确认")]), _vm._v(" "), _c('div', [_vm._v("详情")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "user-wrap"
  }, [_vm._l((_vm.user.bonusData.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(((item.cycle_year) + "年#" + (item.cycle_number))))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("justDate")(item.cycle_start)) + "至" + _vm._s(_vm._f("justDate")(item.cycle_end)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.confirm_time ? item.confirm_time : "-- --"))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.confirm_time ? "是" : "否"))]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          _vm.showBill(item)
        }
      }
    }, [_vm._v("详情")])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.user.bonusData.list
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    staticClass: "inside",
    attrs: {
      "data": _vm.user.bonusData
    },
    on: {
      "getPage": _vm.bonusSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.userActiveIndex == 1),
      expression: "user.userActiveIndex==1"
    }]
  }, [_c('div', {
    staticClass: "user-list ticket"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v("罚单编号")]), _vm._v(" "), _c('div', [_vm._v("罚单日期")]), _vm._v(" "), _c('div', [_vm._v("罚单类型")]), _vm._v(" "), _c('div', [_vm._v("罚币金额(币)")]), _vm._v(" "), _c('div', [_vm._v("处罚原因")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "user-wrap"
  }, [_vm._l((_vm.user.ticketData.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.ticket_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.ticket_amount))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.remark
      }
    }, [_vm._v(_vm._s(item.remark))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.user.ticketData.list
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    staticClass: "inside",
    attrs: {
      "data": _vm.user.ticketData
    },
    on: {
      "getPage": _vm.userTicketSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.userActiveIndex == 2),
      expression: "user.userActiveIndex==2"
    }]
  }, [_c('div', {
    staticClass: "user-list pmt"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v("操作日期")]), _vm._v(" "), _c('div', [_vm._v("职级变化")]), _vm._v(" "), _c('div', [_vm._v("当前职级")]), _vm._v(" "), _c('div', [_vm._v("备注")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "user-wrap"
  }, [_vm._l((_vm.user.pmtData.list), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', [_vm._v(_vm._s((item.bill_type == 1 ? "+" : "-") + item.amount))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.balance))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.remark
      }
    }, [_vm._v(_vm._s(item.remark))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.user.pmtData.list
    }
  })], 2)], 1), _vm._v(" "), _c('z-pagination', {
    staticClass: "inside",
    attrs: {
      "data": _vm.user.pmtData
    },
    on: {
      "getPage": _vm.searchUserPmt
    }
  })], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "z-bill",
    attrs: {
      "title": "结算账单",
      "size": 'large',
      "visible": _vm.billFlag
    },
    on: {
      "update:visible": function($event) {
        _vm.billFlag = $event
      }
    }
  }, [_c('div', {
    staticClass: "bill-table"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v("奖金周期")]), _vm._v(" "), _c('div', [_vm._v("快币类型")]), _vm._v(" "), _c('div', [_vm._v("数量")]), _vm._v(" "), _c('div', [_vm._v("当期汇率")]), _vm._v(" "), _c('div', [_vm._v("金额")])]), _vm._v(" "), _vm._l((_vm.bill.list), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(index == 0 ? _vm.bill_cycle : ""))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.currency_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.trans_amount + '币'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.currency_rate))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.trans_number + "元"))])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bill.periodCurrPersonalSummary && _vm.bill.periodCurrPersonalSummary.confirm_money < 0),
      expression: "bill.periodCurrPersonalSummary && bill.periodCurrPersonalSummary.confirm_money < 0"
    }],
    staticClass: "item item-total"
  }, [_c('div', [_vm._v("上期结余")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("bonus")(_vm.bill.periodCurrPersonalSummary)))])]), _vm._v(" "), _c('div', {
    staticClass: "item item-total"
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("bonus")(_vm.bill.currPersonalSummary)))])])], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "newInfo"
  }, [_c('span', {
    staticClass: "point"
  }, [_vm._v(" ")]), _vm._v("红点表示职员在当天收到过罚单\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-6bb06766!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/buManage/page-personManage.vue
// module id = 758
// module chunks = 1